import { PageHero, Reveal } from "../components/common";
import { ORG } from "../data/site";

const SECTIONS = [
  {
    title: "About this website",
    body: `This website is published by ${ORG.name} (Reg. No. ${ORG.registration}), a public charitable trust registered with the Charity Commissioner, Ahmedabad, under the Bombay Public Trusts Act, 1950. It exists to document the Trust's work and to receive enquiries and donation pledges.`,
  },
  {
    title: "Accuracy of content",
    body: "Event photographs, dates, locations and figures shown on this website are drawn from the Trust's own documented records. Where a detail has not been confirmed, it is explicitly marked rather than estimated. If you spot an error, please tell us and we will correct it.",
  },
  {
    title: "Donations",
    body: "The donation form records your intention to donate; no online payment is processed on this website at present. The Trust holds 80G approval from the Commissioner of Income Tax (Exemptions), Ahmedabad; its renewal under the current tax regime is in progress. Please confirm the tax-deduction status of your donation with the Trust before relying on it.",
  },
  {
    title: "Intellectual property",
    body: "All photographs, text and documents on this website belong to the Trust and may not be reproduced for commercial purposes without written permission. You are welcome to share links to this website.",
  },
  {
    title: "External links",
    body: "This website links to the Trust's Facebook page and other external sites. We are not responsible for the content or privacy practices of external websites.",
  },
  {
    title: "Limitation of liability",
    body: "The information on this website is provided in good faith for general purposes. The Trust accepts no liability for any loss arising from reliance on this website or from its temporary unavailability.",
  },
  {
    title: "Governing law",
    body: "These terms are governed by the laws of India, and any dispute shall be subject to the jurisdiction of the courts of Ahmedabad, Gujarat.",
  },
];

export default function Terms() {
  return (
    <>
      <PageHero
        overline="Legal"
        title="Terms & Disclaimer"
        copy="The terms on which this website is provided, in plain language."
      />
      <section className="pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12 space-y-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div className="border-t border-charcoal/15 pt-6">
                <h2 className="font-serif text-2xl font-medium tracking-tight">{s.title}</h2>
                <p className="mt-3 text-sm md:text-base leading-relaxed text-charcoal/70">{s.body}</p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.1}>
            <p className="text-xs text-charcoal/45">
              {ORG.name} · {ORG.address} · {ORG.email}
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
